module.exports = __webpack_public_path__ + "static/bus-on-main-ca8a045f4b9ff41afbda8b3b0bfc8d70.jpg";